// extracted by mini-css-extract-plugin
export var fullGrid = "_2f-3";
export var pdpPreviewContainer = "_2f-1";
export var previewContainer = "_2f-0";
export var togglePreviewContainer = "_2f-2";